<template>
  <Flex v-if="!isFeedbackServerException" pt-3 class="feedback-container">
    <Flex mb-8 class="summary-container">
      {{ $t('updated.recordcount', [numberOfRecordsUpdated, numberOfRecordsSelected]) }}
    </Flex>
    <Flex v-if="isRecordAccessErrors" class="record-access-container">
      <Flex mb-3 class="issue-header">{{ $t('error.permissions') }}</Flex>
      <DataTable
        :pagination="false"
        :showFooter="false"
        :data="recordAccessErrors"
        :columns="[{ property: 'recordId', label: $t('feedback.column.record'), sortable: false }]"
      >
        <template #content:recordId="rowData">
          <a :href="rowData.link" target="blank" class="link-text">{{ rowData.recordId }}</a>
        </template>
      </DataTable>
    </Flex>
    <Flex v-if="isFieldAccessErrors" class="field-access-container">
      <Flex mb-3 class="issue-header">{{ $t('error.permissions') }}</Flex>
      <DataTable
        :pagination="false"
        :showFooter="false"
        :data="fieldAccessErrors"
        :columns="[
          { property: 'recordId', label: $t('feedback.column.record'), sortable: false },
          { property: 'fieldId', label: $t('feedback.column.field'), sortable: false },
        ]"
      >
        <template #content:fieldId="rowData">
          <div class="field-id">{{ rowData.fieldId }}</div>
        </template>
        <template #content:recordId="rowData">
          <a :href="rowData.link" target="blank" class="link-text">{{ rowData.recordId }}</a>
        </template>
      </DataTable>
    </Flex>
    <Flex v-if="isValidationErrors" class="validation-container">
      <Flex mb-3 class="issue-header">{{ $t('error.validationfailed') }}</Flex>
      <DataTable
        :pagination="false"
        :wrap="true"
        :showFooter="false"
        :data="validationErrors"
        :columns="[
          { property: 'recordId', label: $t('feedback.column.record'), sortable: false },
          { property: 'fieldId', label: $t('feedback.column.field'), sortable: false },
          { property: 'validationMessage', label: $t('feedback.column.message'), sortable: false },
        ]"
      >
        <template #content:fieldId="rowData"
          ><div class="field-id">{{ rowData.fieldId }}</div></template
        >
        <template #content:recordId="rowData">
          <a :href="rowData.link" target="blank" class="link-text">{{ rowData.recordId }}</a>
        </template>
        <template #content:validationMessage="rowData"
          ><div class="error-text">{{ rowData.validationMessage }}</div></template
        >
      </DataTable>
    </Flex>
    <Flex v-if="isSaveErrors" class="save-error-container">
      <Flex mb-3 class="issue-header">{{ $t('error.records') }}</Flex>
      <DataTable
        :pagination="false"
        :showFooter="false"
        :data="saveErrors"
        :columns="[
          { property: 'recordId', label: $t('feedback.column.record'), sortable: false },
          { property: 'errorMessage', label: $t('feedback.column.message'), sortable: false },
        ]"
      >
        <template #content:errorMessage="rowData"
          ><div class="text-red-600">{{ rowData.errorMessage }}</div></template
        >
      </DataTable>
    </Flex>
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex.vue'
import DataTable from '@wizer/core/components/data-table/DataTable.vue'
import { mapState } from 'vuex'

export default {
  name: 'BulkUpdateFeedback',
  components: {
    Flex,
    DataTable,
  },
  computed: {
    ...mapState({
      isFeedbackServerException: (state) =>
        state.BulkUpdateFeedbackModule.isFeedbackServerException,
      numberOfRecordsUpdated: (state) => state.BulkUpdateFeedbackModule.numberOfRecordsUpdated,
      numberOfRecordsSelected: (state) => state.BulkUpdateFeedbackModule.numberOfRecordsSelected,
      isRecordAccessErrors: (state) => state.BulkUpdateFeedbackModule.isRecordAccessErrors,
      isFieldAccessErrors: (state) => state.BulkUpdateFeedbackModule.isFieldAccessErrors,
      isValidationErrors: (state) => state.BulkUpdateFeedbackModule.isValidationErrors,
      isSaveErrors: (state) => state.BulkUpdateFeedbackModule.isSaveErrors,
      recordAccessErrors: (state) => state.BulkUpdateFeedbackModule.recordAccessErrors,
      fieldAccessErrors: (state) => state.BulkUpdateFeedbackModule.fieldAccessErrors,
      validationErrors: (state) => state.BulkUpdateFeedbackModule.validationErrors,
      saveErrors: (state) => state.BulkUpdateFeedbackModule.saveErrors,
    }),
  },
}
</script>

<style lang="postcss">
.feedback-container {
  @apply .items-center;
}
.feedback-container,
.record-access-container,
.field-access-container,
.validation-container,
.save-error-container {
  @apply .flex-col;
  @apply .w-5/6;
}
.summary-container {
  @apply .justify-center;
  @apply .text-lg;
}
.issue-header {
  @apply .text-base;
}
.field-id {
  @apply .font-bold;
}
.error-text {
  @apply .text-red-600;
}
.link-text {
  @apply .text-blue-600;
}
</style>
